module.exports = __webpack_public_path__ + "static/img/1_1.c174d363.jpg";